export function getQueryParamCaseInsensitive(searchParams: URLSearchParams, name: string): string | null {
  const lowerName = name.toLowerCase();
  for (const [key, value] of searchParams) {
    if (key.toLowerCase() === lowerName) {
      return value;
    }
  }
  return null;
}

export function getLastQueryParamCaseInsensitive(searchParams: URLSearchParams, name: string): string | null {
  const lowerName = name.toLowerCase();
  let result: string | null = null;
  for (const [key, value] of searchParams) {
    if (key.toLowerCase() === lowerName) {
      result = value;
    }
  }
  return result;
}

const HTTP_UTILITY_URL_SAFE = new Set(['-', '_', '.', '!', '*', '(', ')']);

export function httpUtilityUrlEncode(value: string): string {
  let result = '';
  for (const byte of new TextEncoder().encode(value)) {
    const char = String.fromCharCode(byte);
    if (
      (byte >= 0x41 && byte <= 0x5a) ||
      (byte >= 0x61 && byte <= 0x7a) ||
      (byte >= 0x30 && byte <= 0x39) ||
      HTTP_UTILITY_URL_SAFE.has(char)
    ) {
      result += char;
    } else if (byte === 0x20) {
      result += '+';
    } else {
      result += '%' + byte.toString(16).padStart(2, '0');
    }
  }
  return result;
}
